class ColorSwatchHandler extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Initialize properties
    this.colorType = this.dataset.colorType;
    this.swatches = this.querySelectorAll('.color-radio');
    this.activeColorDisplay = document.getElementById(`active-${this.colorType}-color`);
    this.activeLabel = null;
    
    // Setup event listeners and initialize state
    this.setupEventListeners();
    this.initializeSelectedColor();
  }

  initializeSelectedColor() {
    const checkedSwatch = this.querySelector('.color-radio:checked');
    if (checkedSwatch) {
      this.updateActiveColorDisplay(checkedSwatch.value);
      this.updateSwatchOutline(checkedSwatch);
    }
  }

  setupEventListeners() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('change', (e) => this.handleSwatchChange(e));
      
      // Add hover effects
      const label = document.querySelector(`label[for="${swatch.id}"]`);
      if (label) {
        label.addEventListener('mouseenter', () => this.handleSwatchHover(label, true));
        label.addEventListener('mouseleave', () => this.handleSwatchHover(label, false));
      }
    });
  }

  updateActiveColorDisplay(colorName) {
    if (this.activeColorDisplay) {
      this.activeColorDisplay.textContent = colorName;
    }
  }

  updateSwatchOutline(swatch) {
    // Remove outline from previous active swatch
    if (this.activeLabel) {
      this.activeLabel.style.outlineWidth = '0';
    }
    // Add outline to new active swatch
    const newLabel = document.querySelector(`label[for="${swatch.id}"]`);
    if (newLabel) {
      newLabel.style.outlineWidth = '2px';
      this.activeLabel = newLabel;
    }
  }

  handleSwatchHover(label, isHovering) {
    if (isHovering) {
      label.style.outlineWidth = '1px';
    } else {
      // Only remove outline if this isn't the active swatch
      if (label !== this.activeLabel) {
        label.style.outlineWidth = '0';
      }
    }
  }

  handleSwatchChange(event) {
    const selectedSwatch = event.target;
    const variantId = selectedSwatch.dataset.variantId;
    const productUrl = selectedSwatch.closest('label')?.dataset.productUrl || selectedSwatch.dataset.url;
    const colorName = selectedSwatch.value;
    
    // Update UI
    this.updateActiveColorDisplay(colorName);
    this.updateSwatchOutline(selectedSwatch);

    // Navigate to new variant
    if (productUrl) {
      const newUrl = new URL(productUrl, window.location.origin);
      newUrl.searchParams.set('variant', variantId);
      window.location.href = newUrl.toString();
    }
  }
}

// Register the custom element
customElements.define('custom-color-swatch', ColorSwatchHandler);